import React from "react";
import PropTypes from "prop-types";
import Tooltip from "@/components/Tooltip";
import PlainButton from "@/components/plain-button/PlainButton";
import { localizeTime, durationHumanize } from "@/lib/utils";
import { RefreshScheduleType, RefreshScheduleDefault } from "../proptypes";
import { useTheme } from "@/components/ThemeProvider";

import "./SchedulePhrase.less";

function SchedulePhrase({ schedule, isNew, isLink, onClick }) {
  const { isDarkMode } = useTheme();

  const content = React.useMemo(() => {
    const { interval: seconds } = schedule || SchedulePhrase.defaultProps.schedule;
    if (!seconds) {
      return ["Never"];
    }
    const humanized = durationHumanize(seconds, {
      omitSingleValueNumber: true,
    });
    const short = `Every ${humanized}`;
    let full = `Refreshes every ${humanized}`;

    const { time, day_of_week: dayOfWeek } = schedule;
    if (time) {
      full += ` at ${localizeTime(time)}`;
    }
    if (dayOfWeek) {
      full += ` on ${dayOfWeek}`;
    }

    return [short, full];
  }, [schedule]);

  if (isNew) {
    return "Never";
  }

  const [short, full] = content;
  const phraseContent = full ? <Tooltip title={full}>{short}</Tooltip> : short;

  return isLink ? (
    <PlainButton 
      type="link" 
      className={`schedule-phrase ${isDarkMode ? 'dark-mode' : ''}`} 
      onClick={onClick} 
      data-test="EditSchedule"
    >
      {phraseContent}
    </PlainButton>
  ) : (
    <span className={`schedule-phrase ${isDarkMode ? 'dark-mode' : ''}`}>{phraseContent}</span>
  );
}

SchedulePhrase.propTypes = {
  schedule: RefreshScheduleType,
  isNew: PropTypes.bool.isRequired,
  isLink: PropTypes.bool,
  onClick: PropTypes.func,
};

SchedulePhrase.defaultProps = {
  schedule: RefreshScheduleDefault,
  isLink: false,
  onClick: () => {},
};

export default SchedulePhrase;
